module.exports = __webpack_public_path__ + "img/about-1.07c0df0.jpg";